import { render, staticRenderFns } from "./CrudList.vue?vue&type=template&id=d5f7929e&scoped=true"
import script from "./CrudList.vue?vue&type=script&lang=js"
export * from "./CrudList.vue?vue&type=script&lang=js"
import style0 from "./CrudList.vue?vue&type=style&index=0&id=d5f7929e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f7929e",
  null
  
)

export default component.exports